module.exports = __webpack_public_path__ + "static/media/blogpost5.e69ff2ea.jpg";